import React from "react";
import {
  POWERED_BY_VARIANT,
  trackPoweredByClick,
  gradientTextStyle,
} from "./../../shared/poweredByVariants";

// Footer attribution pill for Wall of Love public pages. White bg + tinted
// gradient "Shosay" — visual is shared with the widget PoweredBy in
// app/javascript/widget/public/shared/PoweredBy.jsx. The variant + tracking
// live in app/javascript/shared/poweredByVariants.js so all surfaces agree.
const PoweredByShosay = () => (
  <footer className="text-center pb-8">
    <a
      href="https://shosay.com/?utm_medium=powered_by&utm_source=public_link"
      target="_blank"
      rel="noopener"
      onClick={() => trackPoweredByClick(POWERED_BY_VARIANT.key)}
      data-variant={POWERED_BY_VARIANT.key}
      className="inline-flex items-center gap-1.5 bg-white border border-black/15 rounded-full px-3 py-1.5 text-xs font-medium text-slate-600 shadow-sm hover:shadow-md hover:bg-white transition-shadow no-underline"
    >
      <span>Powered by</span>
      <span style={gradientTextStyle(POWERED_BY_VARIANT)}>Shosay</span>
    </a>
  </footer>
);

export default PoweredByShosay;
